// Central testIds so we can attach data-testid consistently
export const IDS = {
  nav: "site-nav",
  navLogo: "nav-logo",
  navRequestDemo: "nav-request-demo",
  heroCta: "hero-cta-request-demo",
  heroSecondaryCta: "hero-cta-see-how",
  heroCounterEvidence: "hero-counter-evidence",
  heroCounterControls: "hero-counter-controls",
  heroCounterFrameworks: "hero-counter-frameworks",
  heroResetButton: "hero-reset-button",
  evidenceChip: (id) => `evidence-chip-${id}`,
  frameworkNode: (id) => `framework-node-${id}`,
  frameworkGridItem: (id) => `framework-grid-${id}`,
  frameworkToggle: (id) => `framework-toggle-${id}`,
  hashTamperToggle: "hash-tamper-toggle",
  faqItem: (id) => `faq-item-${id}`,
  demoForm: "demo-form",
  demoNameField: "demo-form-name",
  demoEmailField: "demo-form-email",
  demoCompanyField: "demo-form-company",
  demoMessageField: "demo-form-message",
  demoFrameworkChip: (id) => `demo-fwk-${id}`,
  demoSubmit: "demo-form-submit",
  demoSuccess: "demo-form-success",
  finalCta: "final-cta-request-demo",
  footerLink: (id) => `footer-link-${id}`,
};
